import { AsyncPipe, NgIf } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { Countertop } from '../../../models/cutting/countertop';
import { CountertopSettingsStateService } from '../countertop-settings-state.service';

export class PanelsJointBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _PanelsJointMixinBase = mixinDisabled(PanelsJointBase);

@Component({
  selector: 'csl-panels-joint',
  template: `<mat-checkbox
    *ngIf="data$ | async as data"
    [checked]="data.useClampJointForPanels"
    [disabled]="disabled"
    (change)="toggle($event.checked, data)"
    i18n
    >Соединять части стяжками</mat-checkbox
  >`,
  inputs: ['disabled'],
  standalone: true,
  imports: [MatLegacyCheckboxModule, AsyncPipe, NgIf],
})
export class PanelsJointComponent extends _PanelsJointMixinBase implements CanDisable {

  @HostBinding('class') classes = 'py-4 block'

  data$ = this.countertopSettingsService.countertop$;

  constructor(private countertopSettingsService: CountertopSettingsStateService) {
    super();
  }

  toggle(isJoin: boolean, countertop: Countertop): void {
    countertop.useClampJointForPanels = isJoin;

    this.countertopSettingsService.updateCountertop(countertop);
  }
}
